import { render, staticRenderFns } from "./AutomaticPaymentTriggers.vue?vue&type=template&id=ed44452a&"
import script from "./AutomaticPaymentTriggers.vue?vue&type=script&lang=ts&"
export * from "./AutomaticPaymentTriggers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports